import PropTypes from 'prop-types'

import {useSuiContext} from '@s-ui/react-context'
import IconCheckSmall from '@adv-mt/mt-svg-icons/lib/CheckSmall.js'
import {Icon, ICON_INTENTS, ICON_SIZES} from '@adv-mt/ui/icon'
import {Body1, Subhead1} from '@adv-mt/ui/typography'

import {BASE_CLASS as PAGE_BASE_CLASS} from '../../config.js'
import BaseDrawer from '../BaseDrawer/index.js'

const BASE_CLASS = `${PAGE_BASE_CLASS}-noCommissionsDrawer`

const FEATURE_KEYS = [
  'DETAIL_NO_COMMISSIONS_TRANSPARENT_PURCHASE',
  'DETAIL_NO_COMMISSIONS_SELLER_PRICE',
  'DETAIL_NO_COMMISSIONS_NO_CONTACT_COST'
]

const NoCommissionsDrawer = ({onClose}) => {
  const {domain, i18n} = useSuiContext()

  const config = domain.get('config')
  const appName = config.get('APP_NAME')
  const siteName = config.get('SITE_NAME')

  return (
    <BaseDrawer onClose={onClose} title={i18n.t('COMMON.DETAIL_TRUST_TITLE')}>
      <div className={`${BASE_CLASS}-content`}>
        <Subhead1 as="h3">{i18n.t(`COMMON.DETAIL_NO_COMMISSIONS_DRAWER_TITLE_${appName}`)}</Subhead1>

        <ul className={`${BASE_CLASS}-list`}>
          {FEATURE_KEYS.map(key => (
            <li className={`${BASE_CLASS}-item`} key={key}>
              <Icon size={ICON_SIZES.MD} intent={ICON_INTENTS.PRIMARY}>
                <IconCheckSmall size={ICON_SIZES.MD} />
              </Icon>
              <div className={`${BASE_CLASS}-itemContent`}>
                <Body1 highlight>{i18n.t(`COMMON.${key}`)}</Body1>
                <Body1>{i18n.t(`COMMON.${key}_DESCRIPTION`, {siteName})}</Body1>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </BaseDrawer>
  )
}

NoCommissionsDrawer.displayName = 'NoCommissionsDrawer'

NoCommissionsDrawer.propTypes = {
  onClose: PropTypes.func.isRequired
}

export default NoCommissionsDrawer
